import { render, staticRenderFns } from "./TradingMarketTable.vue?vue&type=template&id=7bcc44cf"
import script from "./TradingMarketTable.vue?vue&type=script&lang=js"
export * from "./TradingMarketTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports